import moment from 'moment-timezone';
import LoadingComponent from '@/modules/ifrs9/components/LoadingComponent.vue';
import CoreMixin from '@/mixins/core.mixin';
import { mapGetters } from 'vuex';

export default {
  mixins: [CoreMixin],
  computed: {
    ...mapGetters('coreModule', [
      'activeCompany',
      'activeBranches',
      'branches',
      'apps'
    ]),
    ...mapGetters('authModule', ['user'])
  },
  methods: {
    getEnabledStatus: function (val) {
      return val ? "Enabled" : "Disabled";
    },
    showError: function (msg) {
      this.showSnack({
        color: 'error',
        title: `Something went wrong`,
        message: msg
      });
    },
    showSuccess: function (msg) {
      this.showSnack({
        color: 'success',
        title: `Success`,
        message: msg
      });
    },
    checkAuth: function (priv) {
      try {
        let result = this.user.roleObject?.permissions?.findIndex(p => p.name === priv && p.app === "PD-Pro");
        return result !== -1;
      } catch (e) {
        console.log("Exception checking auth", e);
        this.showError("An exception occurred while checking auth");
      }
      return false;
    },
    formatDate: function (date, format) {
      return moment(date).format(format);
    },
    twoDecimal: function (item) {
      return parseFloat(item).toFixed(2);
    },
    //Returns value as money
    asMoney:  function (val) {
      val = isFinite(val) ? val : 0;
      if(val === undefined || isNaN(val) || val === null){
        return "$ 0.00";
      }
      return "$ " + (parseFloat(val)).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    //Returns value as a percent
    asPercent: function (val) {
      val = isFinite(val) ? val : 0;
      if(val === undefined || isNaN(val) || val === null){
        return 0;
      }
      return (parseFloat(val) * 100).toFixed(2) + "%";
    },
    //Returns value as months
    asMonths: function(val) {
      val = isFinite(val) ? val : 0;
      if(val === undefined || isNaN(val) || val === null){
        return 0;
      }
      return (parseFloat(val)).toFixed(2) + ((val == 1) ? " Mth":" Mths");
    },
  },
  components: {
    LoadingComponent,
  }
}